const B2BLoadingSkeletonProductList = () => {
	return (
		<div
			className="mx-auto max-w-xl px-4 py-10 sm:px-6 sm:py-18 lg:max-w-5xl lg:px-8"
			data-test="loading-skeleton-product-list"
		>
			<div className="bg-gray-200 h-7 w-[13rem] rounded" />
			<div className="my-8 grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-6 xl:gap-x-8">
				{[...Array(10)].map((_, index) => (
					<div key={index + 2} className="flex flex-col gap-5">
						<div className="flex flex-col gap-3">
							<div className="bg-gray-200 h-[15rem] rounded" />
							<div className="bg-gray-200 h-6 rounded w-[11rem]" />
							<div className="bg-gray-200 h-3 rounded w-20" />
						</div>
						<div className="bg-gray-200 h-8 rounded" />
					</div>
				))}
			</div>
		</div>
	);
};

export default B2BLoadingSkeletonProductList;
